<script>
  import { BRAND } from '../../config';

  export let size = 'md';
  export let centered = true;

  const heights = {
    sm: '2.25rem',
    md: '3.5rem',
    lg: '4.5rem',
  };
</script>

<div class="brand-logo {centered ? 'mx-auto' : ''}" style="--logo-h: {heights[size]}">
  <img src={BRAND.logo} alt={BRAND.name} />
</div>

<style>
  .brand-logo img {
    height: var(--logo-h);
    width: auto;
    max-width: 100%;
    object-fit: contain;
    object-position: center;
    display: block;
  }
</style>
